import flatpickr from 'flatpickr';

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.individual')) {
        const dateOfBirthFields = document.querySelectorAll('.individual__date-field .datepicker');
        flatpickr(dateOfBirthFields, {
            wrap: true,
            static: true,
            allowInput: true,
            dateFormat: 'm/d/Y'
        });
    }
});

